<template>
  <div>
    <vgp-label-slot
      :label="locales('filter_number_type_custom_column_from')"
      :style="{ marginBottom: '8px' }"
    >
      <template #body>
        <div :class="$style.picker_container">
          <div
            v-click-outside="() => toggleDatePicker('from', false)"
            :class="$style.datetime_container"
          >
            <div @click="() => !datePickerDisplay.from && toggleDatePicker('from', true)">
              <vgp-input
                :key="componentKey"
                gp-autotest-name="gp_autotest_filter_option_date_from"
                :model-value="formatDateValue(rangeValue.from)"
                :style="{ width: '100%' }"
                :small="true"
                :icons-left="[{ name: 'calendar', handler: handleCalendarIconClickFrom }]"
                @onChange="$event => handleChangeDate('from', $event.target.value)"
              />
            </div>

            <vgp-date-picker
              v-if="datePickerDisplay.from"
              :class="$style.date_picker_popup"
              :value="rangeValue.from"
              :has-footer-slot="true"
              :is-custom-date-column="true"
              @onChange="$event => handleChangeDate('from', $event)"
            />
          </div>

          <div
            v-click-outside="() => toggleTimepicker('from', false)"
            :class="$style.datetime_container"
          >
            <div @click="() => !timePickerDisplay.from && toggleTimepicker('from', true)">
              <vgp-input
                :key="componentKey"
                gp-autotest-name="gp_autotest_filter_option_time_from"
                :model-value="timeValue.from"
                :style="{ width: '100%' }"
                :small="true"
                :icons-left="[{ name: 'time', handler: handleTimeIconClickFrom }]"
                @onChange="onChangeTimeInput('from', $event.target.value)"
              />
            </div>

            <vgp-time-picker
              v-if="timePickerDisplay.from"
              :class="$style.time_picker_popup"
              :current-date="rangeValue.from"
              :time-format="timeFormat"
              :date-type="''"
              :visible="true"
              @changeTime="$event => handleChangeDate('from', $event)"
            />
          </div>
        </div>
      </template>
    </vgp-label-slot>

    <vgp-label-slot
      :label="locales('filter_number_type_custom_column_to')"
    >
      <template #body>
        <div :class="$style.picker_container">
          <div
            v-click-outside="() => toggleDatePicker('to', false)"
            :class="$style.datetime_container"
          >
            <div @click="() => !datePickerDisplay.to && toggleDatePicker('to', true)">
              <vgp-input
                :key="componentKey"
                gp-autotest-name="gp_autotest_filter_option_date_to"
                :model-value="formatDateValue(rangeValue.to)"
                :style="{ width: '100%' }"
                :small="true"
                :icons-left="[{ name: 'calendar', handler: handleCalendarIconClickTo }]"
                @onChange="$event => handleChangeDate('to', $event.target.value)"
              />
            </div>

            <vgp-date-picker
              v-if="datePickerDisplay.to"
              :class="$style.date_picker_popup"
              :value="rangeValue.to"
              :has-footer-slot="true"
              :is-custom-date-column="true"
              @onChange="$event => handleChangeDate('to', $event)"
            />
          </div>

          <div
            v-click-outside="() => toggleTimepicker('to', false)"
            :class="$style.datetime_container"
          >
            <div @click="() => !timePickerDisplay.to && toggleTimepicker('to', true)">
              <vgp-input
                :key="componentKey"
                gp-autotest-name="gp_autotest_filter_option_time_to"
                :model-value="timeValue.to"
                :style="{ width: '100%' }"
                :small="true"
                :icons-left="[{ name: 'time', handler: handleTimeIconClickTo }]"
                @onChange="$event => onChangeTimeInput('to', $event.target.value)"
              />
            </div>

            <vgp-time-picker
              v-if="timePickerDisplay.to"
              :class="$style.time_picker_popup"
              :current-date="rangeValue.to"
              :time-format="timeFormat"
              :date-type="''"
              :visible="true"
              @changeTime="$event => handleChangeDate('to', $event)"
            />
          </div>
        </div>
      </template>
    </vgp-label-slot>
  </div>
</template>
<script>
import moment from 'moment';
import vgpDatePicker from '../../common/VueComponents/datePicker/vgpDatePicker.vue';
import vgpInput from '$$uiKitComp/vInput/vgpInput.vue';
import vgpLabelSlot from '$$uiKitComp/vInput/vgpLabelSlot.vue';
import filterConstants from '../constants';
import vgpTimePicker from '../../common/VueComponents/datePicker/vgpTimePicker.vue';
import globalToast from '$$uiKitComp/toast';

export default {
  name: 'FilterDateTimeItem',
  components: {
    vgpTimePicker, vgpDatePicker, vgpInput, vgpLabelSlot,
  },
  props: {
    filterItems: { type: Array, required: false, default: () => [] },
  },
  emits: {
    changeFilter: Object,
  },
  data() {
    return {
      locales: __,
      rangeValue: { from: '', to: '' },
      timeValue: { from: '', to: '' },
      timePickerDisplay: {
        from: false,
        to: false,
      },
      datePickerDisplay: {
        from: false,
        to: false,
      },
      componentKey: 0,
    };
  },
  computed: {
    timeFormat() {
      return user.timeFormat;
    },
  },
  watch: {
    filterItems: {
      handler() {
        this.setValues();
      },
      immediate: true,
    },
  },
  created() {
    moment.locale('en');
  },
  methods: {
    setValues() {
      this.filterItems.forEach(item => {
        if (item.property === filterConstants.PROPERTY.date) {
          const value = item.value;

          if (!value || value === '') {
            this.rangeValue.from = new Date();
            this.rangeValue.to = new Date();
          } else {
            this.rangeValue.from = value?.start;
            this.rangeValue.to = value?.end;
          }
        }

        if (item.property === filterConstants.PROPERTY.time) {
          const value = item.value;

          if (!value || value === '') {
            this.timeValue.from = this.getTime(this.rangeValue.from);
            this.timeValue.to = this.getTime(this.rangeValue.to);
          } else {
            this.timeValue.from = this.getTime(value.start);
            this.timeValue.to = this.getTime(value.end);
          }
        }
      });
    },
    formatDateValue(date) {
      return moment(date).format(user.dateFormat);
    },
    handleChangeDate(prop, val) {
      this.datePickerDisplay[prop] = false;
      this.timePickerDisplay[prop] = false;
      this.componentKey++;

      const parsedDate = moment(val, user.dateFormat, true);

      if (!parsedDate.isValid()) {
        globalToast.warning(__('gantt_date_invalid'));

        return;
      }

      const value = {
        start: this.rangeValue.from,
        end: this.rangeValue.to,
      };

      if (prop === 'from') {
        value.start = parsedDate.toDate();
      }

      if (prop === 'to') {
        value.end = parsedDate.toDate();
      }

      this.$emit('changeFilter', {
        [filterConstants.PROPERTY.date]: value,
        [filterConstants.PROPERTY.time]: value,
      });
    },
    onChangeTimeInput(prop, val) {
      this.timePickerDisplay[prop] = false;
      this.componentKey++;

      const parsedTime = moment(val, user.timeFormat ? 'HH:mm' : 'hh:mm A', true);

      if (!parsedTime.isValid()) {
        globalToast.warning(__('gantt_date_invalid'));

        return;
      }

      const parsedDate = moment(this.rangeValue[prop]).set({
        hour: parsedTime.hours(),
        minute: parsedTime.minutes(),
      });

      const value = {
        start: this.rangeValue.from,
        end: this.rangeValue.to,
      };

      switch (prop) {
        case 'from':
          value.start = parsedDate.toDate();
          break;
        case 'to':
          value.end = parsedDate.toDate();
          break;
      }

      const changes = {
        [filterConstants.PROPERTY.date]: value,
        [filterConstants.PROPERTY.time]: value,
      };

      this.timeValue[prop] = this.getTime(parsedTime.toDate());

      this.$emit('changeFilter', changes);
    },
    getTime(value) {
      if (!value) return '';
      const momentTimeFormat = user.timeFormat ? 'HH:mm' : 'hh:mm A';

      return moment(value).locale('en').format(momentTimeFormat);
    },
    toggleTimepicker(prop, flag) {
      this.timePickerDisplay[prop] = flag;
    },
    toggleDatePicker(prop, flag) {
      this.datePickerDisplay[prop] = flag;
    },
    handleCalendarIconClickFrom() {
      this.toggleDatePicker('from', !this.datePickerDisplay.from);
    },
    handleCalendarIconClickTo() {
      this.toggleDatePicker('to', !this.datePickerDisplay.to);
    },
    handleTimeIconClickFrom() {
      this.toggleTimepicker('from', !this.timePickerDisplay.from);
    },
    handleTimeIconClickTo() {
      this.toggleTimepicker('to', !this.timePickerDisplay.to);
    },
  },
};
</script>
<style module lang='less'>

.picker_container {
  display: flex;
  align-items: center;
  gap: 8px;

  .datetime_container {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    position: relative;

    > div {
      width: 100%;
    }
  }

  .time_picker_popup {
    position: absolute;
    top: 36px;
    right: 0;
    z-index: 100;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 9px 22px -2px rgba(0, 0, 0, 0.20);
    padding-top: 16px;
    overflow: hidden;
      width: 258px !important;
  }

  .date_picker_popup {
    position: absolute;
    top: 36px;
    left: 0;
    z-index: 100;
    width: 258px !important;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 9px 22px -2px rgba(0, 0, 0, 0.20);
    overflow: hidden;
  }
}
</style>
